let mm = gsap.matchMedia();

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

  let 	panelsContainer = document.querySelector("#h-slideshow"),
	tween,tl1,tween2;

  const container = document.querySelector(".horizontal-slideshow");
      const panels = gsap.utils.toArray(".horizontal-slide");
      const scrollDistance = container.offsetWidth*2;
      

  // mm.add("(min-width: 2001px)", () => {
  //   const scrollTween = gsap.to(panels,{xPercent:-100*(panels.length-1),ease:"none"});


  //     ScrollTrigger.create({
  //       trigger: container,
  //       pin: true,
  //       scrub: 2,
  //       animation: scrollTween,
  //       end: "+=" + scrollDistance,
  //       snap: .5 / (panels.length - 1),
  //       invalidateOnRefresh:true
  //     });
 
  // });

mm.add("(min-width: 1681px) and (max-width:4000px)", () => {
  
    const scrollTween = gsap.to(panels,{xPercent:-100*(panels.length-1),ease:"none"});


      ScrollTrigger.create({
        trigger: container,
        pin: true,
        scrub: 2,
        animation: scrollTween,
        end: "+=" + scrollDistance,
        snap: .5 / (panels.length - 1),
        invalidateOnRefresh:true
      });

      panels.forEach((panel,i)=>{
        if(i>0){
          const tml = gsap.timeline({
            duration: .1,
                scrollTrigger:{
                  trigger: panel,
                  containerAnimation: scrollTween,
                  start: i === 1 ? "0% 80%" : "0% 90%",
                  end:  i === 1 ? "1400px 80%" : "1200px 50%",
                  scrub:true,
                  invalidateOnRefresh:true,
                  pinSpacing:false,
                  
                }
          });


          

            if(i==1){
              tml.to(".slide-2 .floater",{x:"25%",duration:2},"=-1");
              tml.from(panel.querySelector("h2"),{opacity:0,x:"-50%",duration:2, ease:"ease.out"})
            .from(panel.querySelector("p"),{opacity:0,x:"-50%",duration:2, ease:"ease.out"})
            .from(panel.querySelector(".slide-btn"),{opacity:0,y:50,skew:15,duration:2, ease:"ease.out"});
              tml.to(".slide-3 .floater",{x:"-50%",duration:2},"=1");
              
            }
            if(i==2){

              const badge1 = panel.querySelector(".badge-1");
              const badge2 = panel.querySelector(".badge-2");


              tml.to(".slide-3 .floater",{x:"1%",duration:3},"1");

               tml.from(panel.querySelector("h2"),{opacity:0,x:"-50%",duration:2, ease:"ease.out"})
              .from(panel.querySelector("p"),{opacity:0,x:"-50%",duration:2, ease:"ease.out"})
              .from(panel.querySelector(".slide-btn"),{opacity:0,y:50,skew:15,duration:2, ease:"ease.out"});

              tml.from(badge1,{rotation:-45,x:-100,opacity:0, scale:3,duration:3 },"5");
              tml.from(badge2,{rotation:-45,opacity:0,scale:3,duration:3 },"=10");
              tml.to(badge1,{opacity:0,duration:5 },"=-1");
              tml.from(badge1,{opacity:0,duration:5 });

            }

            
            
        }

          if(i===0){
            const tml1 = gsap.timeline();
            tml1.from(panel.querySelector("h2"),{opacity:0,x:50,duration:0.5})
            .from(panel.querySelector("p"),{opacity:0,x:50,duration:0.5})
            .from(panel.querySelector(".slide-btn"),{opacity:0,y:50,duration:0.5})
            .from(panel.querySelector(".floater"),{opacity:0,y:"-50%",duration:1},"=-1")
            .from(".slide-2 .floater",{opacity:0,x:"50%",duration:1,},"=-1")
          }

        
       
          
      
      });



});


mm.add("(min-width: 1440px) and (max-width: 1680px)", () => {
  

const scrollTween = gsap.to(panels,{xPercent:-100*(panels.length-1),ease:"none"});

      ScrollTrigger.create({
        trigger: container,
        pin: true,
        scrub: 3,
        animation: scrollTween,
        end: "+=" + scrollDistance,
        snap: .1 / (panels.length - 1),
        invalidateOnRefresh:true
      });

      panels.forEach((panel,i)=>{
        if(i>0){
          const tml = gsap.timeline({
            duration: .1,
                scrollTrigger:{
                  trigger: panel,
                  containerAnimation: scrollTween,
                  start:"top 50%",
                  end:  "600px center" ,
                  scrub:true,
                  invalidateOnRefresh:true,
                  pinSpacing:false,
                }
          });


          

            if(i==1){
              tml.from(panel.querySelector("h2"),{opacity:0,x:"-50%",duration:2, ease:"ease.out"})
            .from(panel.querySelector("p"),{opacity:0,x:"-50%",duration:2, ease:"ease.out"})
            .from(panel.querySelector(".slide-btn"),{opacity:0,y:50,skew:15,duration:2, ease:"ease.out"});
              tml.to(".slide-3 .floater",{x:"-25%",duration:2},"=1");
            }

            if(i==2){

              tml.to(".slide-3 .floater",{x:"20%",duration:3, ease:"ease.out"},"=1");
              tml.from(panel.querySelector("h2"),{opacity:0,x:"-50%",duration:2, ease:"ease.out"})
            .from(panel.querySelector("p"),{opacity:0,x:"-50%",duration:2, ease:"ease.out"})
            .from(panel.querySelector(".slide-btn"),{opacity:0,y:50,skew:15,duration:2, ease:"ease.out"});

              const badge1 = panel.querySelector(".badge-1");
              const badge2 = panel.querySelector(".badge-2");


              
              tml.from(badge1,{rotation:-45,x:-100,opacity:0, scale:3,duration:3 },"5");
              tml.from(badge2,{rotation:-45,opacity:0,scale:3,duration:3 },"=5");
              tml.to(badge1,{opacity:0,duration:.5 },"=-1");

            }

            
        }

          if(i===0){
            const tml1 = gsap.timeline();
            tml1.from(panel.querySelector("h2"),{opacity:0,x:50,duration:0.5})
            .from(panel.querySelector("p"),{opacity:0,x:50,duration:0.5})
            .from(panel.querySelector(".slide-btn"),{opacity:0,y:50,duration:0.5})
            .from(panel.querySelector(".floater"),{opacity:0,y:"-50%",duration:1},"=-1")
            .from(".slide-2 .floater",{opacity:0,x:"50%",duration:1,},"=-1")
          }

        
       
          
      
      });



});

mm.add("(max-width: 1439px)", () => {

  const tmlm = gsap.timeline();
            tmlm.from(".slide-1 h2",{opacity:0,x:50,duration:.75})
            .from(".slide-1  p",{opacity:0,x:50,duration:.75})
            .from(".slide-1   .slide-btn",{opacity:0,y:50,duration:.75})
            .from(".slide-1  .floater",{opacity:0,y:"-50%",duration:1, ease:"ease.out"},"=-1")
            .from(".slide-2  .floater-mobile",{opacity:0,y:"50%",x:"-50%",duration:1, ease:"ease.out"},"=-1");

    const tls = gsap.timeline();

    tls.from(".slide-2 h2",{
      scrollTrigger:{
        trigger:".slide-2",
        scrub:2,
        start: "0 70%",
        end: "30% 70%",
       
      },
        y:"100%",
        opacity:0,
        skewX:-15,
        ease:"ease.out"
      });

      tls.from(".slide-2 p",{
      scrollTrigger:{
        trigger:".slide-2",
        scrub:2,
        start: "0 50%",
        end: "10% 50%",
        
      },
        y:"100%",
        opacity:0,
        skewX:-15,
        ease:"ease.out"
      });

      tls.from(".slide-2 .slide-btn",{
      scrollTrigger:{
        trigger:".slide-2",
        scrub:2,
        start: "0 50%",
        end: "10% 50%",
       
      },
        y:"100%",
        opacity:0,
        skewX:-15,
        ease:"ease.out"
      });


      tls.from(".slide-3 h2",{
      scrollTrigger:{
        trigger:".slide-3",
        scrub:2,
        start: "0 70%",
        end: "30% 70%",
       
      },
        y:"100%",
        opacity:0,
        skewX:-15,
        ease:"ease.out"
      });

      tls.from(".slide-3 .floater-mobile",{
      scrollTrigger:{
        trigger:".slide-3",
        scrub:2,
        start: "0 70%",
        end: "10% 70%",
       
      },
        x:"50%",
        opacity:0,
        ease:"ease.out"
      });
      

      tls.from(".slide-3 p",{
      scrollTrigger:{
        trigger:".slide-3",
        scrub:2,
        start: "0 50%",
        end: "10% 50%",
        
      },
        y:"100%",
        opacity:0,
        skewX:-15,
        ease:"ease.out"
      });

      tls.from(".slide-3 .slide-btn",{
      scrollTrigger:{
        trigger:".slide-3",
        scrub:2,
        start: "0 50%",
        end: "10% 50%",
       
      },
        y:"100%",
        opacity:0,
        skewX:-15,
        ease:"ease.out"
      });

      tls.from(".slide-3 .badge-1",{
      scrollTrigger:{
        trigger:".slide-3",
        scrub:2,
        start: "0 50%",
        end: "5% 50%",
       
      },
        opacity:0,
        scale:3,
        ease:"ease.out"
      });

      tls.from(".slide-3 .badge-2",{
      scrollTrigger:{
        trigger:".slide-3",
        scrub:2,
        start: "0 30%",
        end: "5% 30%",
       
      },
        opacity:0,
        scale:3,
        ease:"ease.out"
      },"=5");


});


  // //Horizontal Slide Script

  // ScrollTrigger.matchMedia({
  //   "((min-width:1440px) and (max-width:1679px))": function(){
      


  //   },

  //   "(max-width:1680px)": function(){
  //     alert(1680)
  //       ScrollTrigger.create({
  //       trigger: container,
  //       pin: true,
  //       scrub: 3,
  //       animation: scrollTween,
  //       end: "+=" + scrollDistance,
  //       snap: .5 / (panels.length - 1),
  //       invalidateOnRefresh:true
  //     });

  //     panels.forEach((panel,i)=>{
  //       if(i>0){
  //         const tml = gsap.timeline({
  //           duration: .1,
  //               scrollTrigger:{
  //                 trigger: panel,
  //                 containerAnimation: scrollTween,
  //                 start:"top 50%",
  //                 end:  "800px center" ,
  //                 scrub:true,
  //                 invalidateOnRefresh:true,
  //                 pinSpacing:false,
  //               }
  //         });


  //         tml.from(panel.querySelector("h2"),{opacity:0,x:50,duration:1})
  //           .from(panel.querySelector("p"),{opacity:0,x:50,duration:1})
  //           .from(panel.querySelector(".slide-btn"),{opacity:0,y:50,skew:15,duration:1});

  //           if(i==1){
  //             tml.to(".slide-2 .floater",{x:"25%",duration:2},"=1");
  //             tml.to(".slide-3 .floater",{x:"-25%",duration:2},"=1");
  //           }
  //           if(i==2){
  //             tml.to(".slide-3 .floater",{x:"20%",duration:3, ease:"ease.inOut"},"=1")
  //           }

            
            
  //       }

  //         if(i===0){
  //           const tml1 = gsap.timeline();
  //           tml1.from(panel.querySelector("h2"),{opacity:0,x:50,duration:0.5})
  //           .from(panel.querySelector("p"),{opacity:0,x:50,duration:0.5})
  //           .from(panel.querySelector(".slide-btn"),{opacity:0,y:50,duration:0.5})
  //           .from(panel.querySelector(".floater"),{opacity:0,y:"-50%",duration:1},"=-1")
  //           .from(".slide-2 .floater",{opacity:0,x:"50%",duration:1,},"=-1")
  //         }

          
          
      
  //     });
      

  //   },

  //   "(max-width:1439px)": function(){
     
  //   }


  // });

//     mm.add("(min-width: 1440px)", () => {

//         tl1 = gsap.timeline();
//         tl1.from(".slide-1 h2",{
//             x:"-60%",
//             opacity:0,
//             skewX:10,
//             duration:1,
//             ease:"ease.inOut"
//         });

// tl1.from(".slide-1 .floater",{
//     y:"-100%",
//     rotation:45,
//     transformOrigin: "top right", 
//     duration:5,
//     ease:"power4.inOut"
//   }, "<-2");

//     tl1.from(".slide-1 a.slide-btn",{
//     x:"-60%",
//     opacity:0,
//     skewX:-10,
//     duration:2,
//     ease:"back.inOut"
//   }, "<2");
// tl1.from(".slide-1 p",{
//     y:"-60%",
//     opacity:0,
//     duration:1,
//     ease:"back.inOut"
//   },"<1"
// );
//    tl1.from(".slide-2 .floater",{
//     x:"60%",
//     duration:2,
//     ease:"back.inOut"
//   }, "<0");


//         tween = gsap.timeline({
// 	scrollTrigger: {
// 		trigger: "#h-slideshow",
// 		pin: true,
// 		start: "top top",
// 		scrub: 2,
// 		end:"+=300%",
//      toggleActions:"play none none reverse",
//      invalidateOnRefresh:true,
// 	}
// })
//     .to("#h-slideshow", {
//     x: () =>{
//       if(window.innerWidth >=2400){
//         return -(window.innerWidth *2)
//       }else{
//         return -(window.innerWidth * 2)
//       }
      
//     } ,
//     ease: "none", // <-- IMPORTANT!
//     duration: 1 // 3 sections
//   })

//   .from(".slide-2 .slide-content",{
//   scrollTrigger:{
//     trigger:".slide-2",
//     scrub:3,
//     start: "top top",
//   },
//     x:"100%",
//     opacity:0,
//     skewX:-15,
//     ease:"ease.out"
//   })

//     .from(".slide-3 .floater",{
//         scrollTrigger:{
//             trigger:".slide-3",
//             scrub:3,
//             start: "top top",
//         },
//         x:"100%",

//     })

//     });


let selector  = "#paradice_tubs .tub.two";





      let paradtime = gsap.timeline({
          scrollTrigger: {
            trigger: "paradice_tubs",
            start: "top top",
            scrub: 3,
              pinSpacing:true,
          }
       })
       .from("#paradice_tubs .scrolling-bg-text.even", {
        scrollTrigger: {
          trigger: "#paradice_tubs",
          scrub: 2,
          start: "top 150%",
          end: "+=100%"
        },
        x: "-100%",
        transformOrigin: "left center", 
        ease: "none"
      })
      .from("#paradice_tubs .scrolling-bg-text.odd", {
        scrollTrigger: {
          trigger: "#paradice_tubs",
          scrub: 2,
          start: "top 150%",
          end: "+=100%",
        },
        x: "100%",
        transformOrigin: "left center", 
        ease: "none"
      });

      

      let prottime = gsap.timeline({
          scrollTrigger: {
            trigger: "#protein_pouches",
            start: "top top",
            scrub: 3,
              pinSpacing:true,
          }
       })
       .from("#protein_pouches .scrolling-bg-text.even", {
        scrollTrigger: {
          trigger: "#protein_pouches",
          scrub: 2,
          start: "top 150%",
          end: "+=100%"
        },
        x: "-100%",
        transformOrigin: "left center", 
        ease: "none"
      })
      .from("#protein_pouches .scrolling-bg-text.odd", {
        scrollTrigger: {
          trigger: "#protein_pouches",
          scrub: 2,
          start: "top 150%",
          end: "+=100%",
        },
        x: "100%",
        transformOrigin: "left center", 
        ease: "none"
      });


    ScrollTrigger.matchMedia({

      "(min-width:1440px)": function(){

        
      paradtime.to("#paradice_tubs .tub.one",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#paradice_tubs  .tub.two').offsetHeight*-.1)),
            x: () => ((Math.round(document.querySelector('#paradice_tubs  .tub.two').offsetWidth/3)*-1)),
            ease:"ease.inOut",
            scrollTrigger:{
              trigger:"#paradice_tubs .tub.one",
              start:"-200px 50%",
              end:"10px 65%",
              scrub:3
            }
        })
        .to("#paradice_tubs .tub.two",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#paradice_tubs  .tub.two').offsetHeight*-.1)),
          ease:"ease.inOut",
            scrollTrigger:{
              trigger:"#paradice_tubs .tub.two",
              start:"-200px 50%",
              end:"10px 65%",
              scrub:2
            }
        })
        .to("#paradice_tubs .tub.three",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#paradice_tubs  .tub.two').offsetHeight*-.1)),
            x: () => ((Math.round(document.querySelector('#paradice_tubs  .tub.two').offsetWidth/3))),
            ease:"ease.inOut",
            
            scrollTrigger:{
              trigger:"#paradice_tubs .tub.three",
              start:"-200px 50%",
              end:"10px 65%",
              scrub:3
            }
        });


        prottime.to("#protein_pouches .tub.one",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#protein_pouches  .tub.two').offsetHeight*-.1)),
            x: () => ((Math.round(document.querySelector('#protein_pouches  .tub.two').offsetWidth/3)*-1)),
            ease:"ease.inOut",
            scrollTrigger:{
              trigger:"#protein_pouches .tub.one",
              start:"-200px 50%",
              end:"10px 65%",
              scrub:3
            }
        })
        .to("#protein_pouches .tub.two",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#paradice_tubs  .tub.two').offsetHeight*-.1)),
          ease:"ease.inOut",
            scrollTrigger:{
              trigger:"#protein_pouches .tub.two",
              start:"-200px 50%",
              end:"10px 65%",
              scrub:3
            }
        })
        .to("#protein_pouches .tub.three",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#protein_pouches  .tub.two').offsetHeight*-.1)),
            x: () => ((Math.round(document.querySelector('#protein_pouches  .tub.two').offsetWidth/4))),
            ease:"ease.inOut",
            
            scrollTrigger:{
              trigger:"#protein_pouches .tub.three",
              start:"-200px 50%",
              end:"10px 65%",
              scrub:3
            }
        });
        
      },
      "(max-width:1439px)": function(){
        
       
      paradtime.to("#paradice_tubs .tub.one",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#paradice_tubs  .tub.two').offsetHeight/2*-.1)),
            x: () => -10,
            ease:"ease.inOut",
            scrollTrigger:{
              trigger:"#paradice_tubs .tub.one",
              start:"-300px  top",
              end:"20px 65%",
              scrub:3,
              
            }
        })

        .to("#paradice_tubs .tub.two",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#paradice_tubs  .tub.two').offsetHeight/2*-.1)),
          ease:"ease.inOut",
            scrollTrigger:{
              trigger:"#paradice_tubs .tub.two",
              start:"-300px top",
              end:"20px 65%",
              scrub:3
            }
        })

        .to("#paradice_tubs .tub.three",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#paradice_tubs  .tub.two').offsetHeight/2*-.1)),
            x: () => 10,
            ease:"ease.inOut",
            scrollTrigger:{
              trigger:"#paradice_tubs .tub.three",
              start:"-300px  top",
              end:"20px 65%",
              scrub:3,
              
            }
        });


        prottime.to("#protein_pouches .tub.one",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#protein_pouches  .tub.two').offsetHeight/2*-.1)),
            x: () => ((Math.round(document.querySelector('#protein_pouches  .tub.two').offsetWidth/6)*-1)),
            ease:"ease.inOut",
            scrollTrigger:{
              trigger:"#protein_pouches .tub.one",
              start:"-300px  top",
              end:"20px 65%",
              scrub:3
            }
        })
        .to("#protein_pouches .tub.two",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#paradice_tubs  .tub.two').offsetHeight/2*-.1)),
          ease:"ease.inOut",
            scrollTrigger:{
              trigger:"#protein_pouches .tub.two",
              start:"-300px  top",
              end:"20px 65%",
              scrub:3
            }
        })
        .to("#protein_pouches .tub.three",{
            duration: 1,
            y: () => (Math.round(document.querySelector('#protein_pouches  .tub.two').offsetHeight/2*-.1)),
            x: () => ((Math.round(document.querySelector('#protein_pouches  .tub.two').offsetWidth/6))),
            ease:"ease.inOut",
            
            scrollTrigger:{
              trigger:"#protein_pouches .tub.three",
              start:"-300px  top",
              end:"20px 65%",
              scrub:3
            }
        });
       
        
      }

    });